import { render, staticRenderFns } from "./OrderPayOk.vue?vue&type=template&id=512b30c9&scoped=true&lang=pug&"
import script from "./OrderPayOk.vue?vue&type=script&lang=js&"
export * from "./OrderPayOk.vue?vue&type=script&lang=js&"
import style0 from "./OrderPayOk.vue?vue&type=style&index=0&id=512b30c9&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "512b30c9",
  null
  
)

export default component.exports